import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { oneOfType, node, func, array, bool } from 'prop-types';
import Slider from '@fiverr-private/slider/src';
import { getContext } from '@fiverr-private/fiverr_context';
import { useDidMount } from '../../../hooks';
import { MAX_TILE_WIDTH, MAX_SLIDES_TO_SHOW, customSettings } from './constants';
import { calculateBreakpoints } from './utils';
import './index.scss';

const TilesCarousel = ({ items = [], TileComponent, showSkipButton, onArrowClick }) => {
    const { isTouch } = getContext();
    const [hideSlider, setHideSlider] = useState(false);
    const didMount = useDidMount();

    useEffect(() => {
        if (didMount) {
            setHideSlider(true);

            setTimeout(() => {
                setHideSlider(false);
            }, 0);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [items.length]);

    if (!items.length) {
        return null;
    }

    const width = items.length < MAX_SLIDES_TO_SHOW ? `${items.length * MAX_TILE_WIDTH}px`: '100%';

    const settings = calculateBreakpoints(customSettings, items.length, showSkipButton);

    return (
        <div className={classNames('tiles-carousel', { 'mobile-slider': isTouch })} style={{ width }}>
            {!hideSlider && <Slider items={items}
                freeScroll={isTouch}
                Component={TileComponent}
                onArrowClick={onArrowClick}
                {...settings}/>}
        </div>
    );
};

TilesCarousel.propTypes = {
    items: array,
    isTouch: bool,
    showSkipButton: bool,
    onArrowClick: func,
    TileComponent: oneOfType([
        node,
        func
    ]).isRequired
};

export default TilesCarousel;
